"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNALLOWED_MUTATION_ERR = 'UNALLOWED_MUTATION_ERR';
exports.TARGET_NOT_EXIST_ERR = 'TARGET_NOT_EXIST_ERR';
exports.INVALID_MUTATION_ERR = 'INVALID_MUTATION_ERR';
exports.INVALID_REQUEST_ERR = 'INVALID_REQUEST_ERR';
exports.INVALID_CAPTCHA_ERR = 'INVALID_CAPTCHA_ERR';
exports.USER_NOT_EXISTED_ERR = 'USER_NOT_EXISTED_ERR';
exports.EMAIL_EXISTED_ERR = 'EMAIL_EXISTED_ERR';
exports.INVALID_LOGIN_ERR = 'INVALID_LOGIN_ERR';
exports.INVALID_PASSWORD_ERR = 'INVALID_PASSWORD_ERR';
exports.INVALID_LOGIN_USER_LOCKED = 'INVALID_LOGIN_USER_LOCKED';
exports.INVALID_LOGIN_TIMES = 'INVALID_LOGIN_TIMES';
exports.PROFILE_NOT_EXISTED_ERR = 'PROFILE_NOT_EXISTED_ERR';
exports.ROLE_NOT_EXISTED_ERR = 'ROLE_NOT_EXISTED_ERR';
exports.LOCATION_NOT_EXISTED_ERR = 'LOCATION_NOT_EXISTED_ERR';
exports.CAMPAIGN_NOT_EXISTED_ERR = 'CAMPAIGN_NOT_EXISTED_ERR';
exports.REVENUE_EXISTED = 'REVENUE_EXISTED';
exports.EQUIPMENT_NOT_EXISTED_ERR = 'EQUIPMENT_NOT_EXISTED_ERR';
exports.EQUIPMENT_EXISTED_ERR = 'EQUIPMENT_EXISTED_ERR';
exports.COMMON_DATA_EXISTED_ERR = 'COMMON_DATA_EXISTED_ERR';
exports.COMMON_DATA_NOT_EXISTED_ERR = 'COMMON_DATA_NOT_EXISTED_ERR';
exports.MAIL_HAS_BEEN_SEND_ERR = 'MAIL_HAS_BEEN_SEND_ERR';
exports.CAMPAIGN_MAPPING_NOT_EXISTS = 'CAMPAIGN_MAPPING_NOT_EXISTS';
exports.LOCATION_OF_CAMPAIGN_NOT_EXISTS = 'LOCATION_OF_CAMPAIGN_NOT_EXISTS';
exports.PRICING_EXISTED_ERR = 'PRICING_EXISTED_ERR';
exports.PRICING_NOT_EXISTED_ERR = 'PRICING_NOT_EXISTED_ERR';
//# sourceMappingURL=errorCode.js.map